import React from "react";
import { PrimaryButton, DefaultButton, mergeStyles } from "office-ui-fabric-react";
import { useTranslation } from "react-i18next";
import { buttonS } from "../../styles/formBtns.styles";

export interface NewFormBtnsProps {
  cancelForm: any;
  submitBtnText?: string;
  cancelBtnText?: string;
  disabled?: boolean,
  positionAbsolute?: boolean
  disabledOnlySubmitButton?: boolean
}

const btns = mergeStyles({
  position: "absolute",
  bottom: 30,
  left: 40,
});

const NewFormBtns: React.FC<NewFormBtnsProps> = ({
  cancelForm,
  submitBtnText,
  cancelBtnText,
  disabled,
  disabledOnlySubmitButton = false,
  positionAbsolute = false
}) => {
  const { t } = useTranslation("admin");
  return (
    <div className={positionAbsolute ? btns : ""}>
      <PrimaryButton
        text={submitBtnText ? submitBtnText : t("nav.confirm") as string}
        type="submit"
        styles={buttonS}
        disabled={disabled || disabledOnlySubmitButton}
      />
      <DefaultButton
        text={cancelBtnText ? cancelBtnText : t("nav.cancel") as string}
        type="reset"
        onClick={cancelForm}
        disabled={disabled}
      />
    </div>
  );
};

export default NewFormBtns;
